module.exports = {"id":"214965","name":"Claudio Riaño","rating":"72","photo":"./data/images/photos/1/214965.png","club":{"name":"Necaxa","logo":"./data/images/clubs/Necaxa.png"},"positions":["BU"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ClaudioRiano0.json
// module id = 831
// module chunks = 0